<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>

  <p-card>
    <h1>
      {{ 'label.checkpoints' | translate }}
    </h1>
    <div class="flex justify-end gap-2 mb-5">
      <p-datepicker
        [(ngModel)]="rangeDates"
        selectionMode="range"
        [readonlyInput]="true"
        [showIcon]="true"
        (onSelect)="selectDateRange()"
      />
      <p-iconfield class="ml-2">
        <p-inputicon class="fa-solid fa-magnifying-glass" />
        <input
          type="text"
          pInputText
          (input)="applyGlobalFilter($event)"
          placeholder="Suche"
          class="w-50"
        />
      </p-iconfield>
    </div>
    <p-table
      #checkpoints
      [value]="checkpointService.checkpoints()"
      stripedRows
      showGridlines
      dataKey="id"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      sortField="date"
      [sortOrder]="-1"
      [scrollable]="true"
      [loading]="false"
      [tableStyle]="{ 'min-width': '50rem' }"
      [globalFilterFields]="[
        'station.designation, route.name, tag_name,belt_name, journey.id,journey.device_id',
      ]"
    >
      <ng-template #header>
        <tr>
          <th rowspan="2" pSortableColumn="date" pResizableColumn>
            {{ 'checkpoint.date' | translate }}
            <p-sortIcon field="date" />
            <p-columnFilter
              type="date"
              field="date"
              display="menu"
            ></p-columnFilter>
          </th>
          <th rowspan="2" pSortableColumn="time" pResizableColumn>
            {{ 'checkpoint.time' | translate }}
            <p-sortIcon field="time" />
            <p-columnFilter
              type="date"
              field="date"
              display="menu"
            ></p-columnFilter>
          </th>
          <th
            rowspan="2"
            pSortableColumn="station.designation"
            pResizableColumn
          >
            {{ 'checkpoint.station' | translate }}
            <p-sortIcon field="station.designation" />
            <p-columnFilter
              field="station.designation"
              matchMode="in"
              display="menu"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-multiselect
                  [ngModel]="value"
                  [options]="stationOptions()"
                  placeholder="Alle auswählen"
                  (onChange)="filter($event.value)"
                  optionLabel="label"
                  optionValue="value"
                  [maxSelectedLabels]="1"
                  class="w-full"
                >
                </p-multiselect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th rowspan="2" pSortableColumn="route.name" pResizableColumn>
            {{ 'checkpoint.route' | translate }}
            <p-sortIcon field="route.name" />
            <p-columnFilter
              field="route.name"
              matchMode="in"
              display="menu"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-multiselect
                  [ngModel]="value"
                  [options]="routeOptions()"
                  placeholder="Alle auswählen"
                  (onChange)="filter($event.value)"
                  optionLabel="label"
                  optionValue="value"
                  [maxSelectedLabels]="1"
                  class="w-full"
                >
                </p-multiselect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th rowspan="2" pSortableColumn="tag_name" pResizableColumn>
            {{ 'checkpoint.tagName' | translate }}
            <p-sortIcon field="tag_name" />
            <p-columnFilter
              field="tag_name"
              matchMode="in"
              display="menu"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-multiselect
                  [ngModel]="value"
                  [options]="tagNameOptions()"
                  placeholder="Alle auswählen"
                  (onChange)="filter($event.value)"
                  optionLabel="label"
                  optionValue="value"
                  [maxSelectedLabels]="1"
                  class="w-full"
                >
                </p-multiselect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th rowspan="2" pSortableColumn="belt_name" pResizableColumn>
            {{ 'checkpoint.beltName' | translate }}
            <p-sortIcon field="belt_name" />
            <p-columnFilter
              field="belt_name"
              matchMode="in"
              display="menu"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-multiselect
                  [ngModel]="value"
                  [options]="beltNameOptions()"
                  placeholder="Alle auswählen"
                  (onChange)="filter($event.value)"
                  optionLabel="label"
                  optionValue="value"
                  [maxSelectedLabels]="1"
                  class="w-full"
                >
                </p-multiselect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th rowspan="2" pSortableColumn="journey.device_id" pResizableColumn>
            {{ 'checkpoint.device' | translate }}
            <p-sortIcon field="journey.device_id" />
            <p-columnFilter
              field="journey.device_id"
              matchMode="in"
              display="menu"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-multiselect
                  [ngModel]="value"
                  [options]="deviceOptions()"
                  placeholder="Alle auswählen"
                  (onChange)="filter($event.value)"
                  optionLabel="label"
                  optionValue="value"
                  [maxSelectedLabels]="1"
                  class="w-full"
                >
                </p-multiselect></ng-template
            ></p-columnFilter>
          </th>
          <th rowspan="2" pSortableColumn="journey" pResizableColumn>
            {{ 'checkpoint.journey' | translate }}
            <p-sortIcon field="journey" />
            <p-columnFilter
              field="journey.id"
              matchMode="in"
              display="menu"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-multiselect
                  [ngModel]="value"
                  [options]="journeyOptions()"
                  placeholder="Alle auswählen"
                  (onChange)="filter($event.value)"
                  optionLabel="label"
                  optionValue="value"
                  [maxSelectedLabels]="1"
                  class="w-full"
                >
                </p-multiselect></ng-template
            ></p-columnFilter>
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-checkpoint>
        <tr>
          <td>{{ checkpoint.created_at | date: 'dd.MM.yyyy' : 'Europe/Berlin' }}</td>
          <td>{{ checkpoint.created_at | date: 'HH:mm:ss' : 'Europe/Berlin' }}</td>
          <td>{{ checkpoint.station?.designation }}</td>
          <td>{{ checkpoint.route?.name }}</td>
          <td>{{ checkpoint.tag_name }}</td>
          <td>{{ checkpoint.belt_name }}</td>
          <td>{{ checkpoint.journey?.device_id }}</td>
          <td>{{ checkpoint.journey?.id }}</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
